import type { DataSourceSortInfo } from "@infinite-table/infinite-react";
import type { BacktestItem } from "epsm-api-types/models";

const defaultSortInfo: DataSourceSortInfo<BacktestItem> = [
	{
		field: "date",
		dir: -1,
	},
	{
		field: "ticker",
		dir: 1,
	},
];

type DefaultColumn = Array<keyof BacktestItem | "_id">;

const DEFAULT_COLUMN_ORDER: DefaultColumn = [
	"_id",
	"date",
	"ticker",
	"action_type",
	"adj_close",
	"adj_count",
	"adj_total_shares",
	"profit_and_loss",
	"amount_of_money",
	"cash",
];

const DEFAULT_PAGE_SIZE = 1000;
const DEFAULT_FILTER_DELAY = 400;

const COLUMN_DEFAULT_FLEX = 1;

const LIGHT_GRAY_COLOR = "#c3c3c3";
const GREEN_COLOR = "#009900";
const RED_COLOR = "#990000";
const DARK_COLOR = "#0c0a09";

export default {
	defaultSortInfo,
	DEFAULT_COLUMN_ORDER,
	DEFAULT_PAGE_SIZE,
	DEFAULT_FILTER_DELAY,
	COLUMN_DEFAULT_FLEX,
	LIGHT_GRAY_COLOR,
	DARK_COLOR,
	GREEN_COLOR,
	RED_COLOR,
};
